import { brand, ThemeOption } from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import svgLogoLeft from '@img/sm-logo-left.svg?url';
import svgLogoRight from '@img/sm-logo-right.svg?url';
import styled from 'styled-components';
const Container = styled.section `
  --sectionSpacingTop: var(--sectionSpacing);
  --sectionSpacingBottom: var(--sectionSpacing);

  position: relative;
  scroll-margin: var(--headerHeight) 0 0;

  &[data-allow-scroll-margin='true'] {
    overflow: clip;
  }

  &[data-allow-top-separator='true'] {
    overflow: visible;
  }

  &[data-theme=${ThemeOption.Default}] {
    --accentColor: ${brand.green.dark};
    --accentColorAlt: ${brand.green.dark};
    --accentContrastColor: ${brand.white};
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
  }

  &[data-theme=${ThemeOption.DarkCoral}] {
    --accentColor: ${brand.green.dark};
    --accentColorAlt: ${brand.green.dark};
    --accentContrastColor: ${brand.white};
    --bgColor: ${brand.darkCoral};
    --fgColor: ${brand.white};
  }

  &[data-theme=${ThemeOption.GreenBeige}] {
    --accentColor: ${brand.green.dark};
    --accentColorAlt: ${brand.green.tea};
    --accentContrastColor: ${brand.white};
    --bgColor: ${brand.green.beige};
    --fgColor: ${brand.black};
  }

  &[data-theme=${ThemeOption.GreenMint}] {
    --accentColor: ${brand.green.dark};
    --accentColorAlt: ${brand.green.seafoam};
    --accentContrastColor: ${brand.white};
    --bgColor: ${brand.green.mint};
    --fgColor: ${brand.black};
  }

  &[data-theme=${ThemeOption.Grey}] {
    --accentColor: ${brand.green.dark};
    --accentColorAlt: ${brand.green.dark};
    --accentContrastColor: ${brand.white};
    --bgColor: ${brand.lightGrey};
    --fgColor: ${brand.black};
  }

  /* Negative margin bottom to force overlap */
  &[data-overlap-bottom='true'] {
    margin-bottom: calc(var(--sectionSpacingBottom) * -1);
  }
`;
const Inner = styled.div `
  color: var(--fgColor);
  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);

  /* Don't apply background color for white backgrounds */
  ${Container}:not([data-theme=${ThemeOption.Default}]) & {
    background: var(--bgColor);
  }

  /* Double padding bottom value to reserve space for negative margin */
  [data-overlap-bottom='true'] & {
    padding-bottom: calc(var(--sectionSpacingBottom) * 2);
  }
`;
/*
 * We have to use elements instead of pseudo-elements to be able to inherit css variables.
 * Ref: https://stackoverflow.com/questions/58818299/css-variables-not-working-in-dialogbackdrop/63322762#63322762
 */
const Separator = styled.div `
  display: none;

  &[data-top] {
    ${Container}:not([data-s-top='default']) & {
      display: block;
      background: var(--bgColor);
      height: var(--sectionSpacingTop);
      width: 100%;
    }

    [data-s-top='slantLeft'] & {
      clip-path: polygon(0% 100%, 100% 0%, 100% 100%);
    }

    [data-s-top='slantRight'] & {
      clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
    }
  }

  &[data-bottom] {
    ${Container}:not([data-s-bottom='default']) & {
      display: block;
      background: var(--bgColor);
      height: var(--sectionSpacingTop);
      width: 100%;
    }

    [data-s-bottom='slantLeft'] & {
      clip-path: polygon(0% 0%, 100% 0%, 0% 100%);
    }

    [data-s-bottom='slantRight'] & {
      clip-path: polygon(0% 0%, 100% 0%, 100% 100%);
    }
  }
`;
const SeparatorLogo = styled.div `
  display: none;

  @media ${from(Device.DesktopSmall)} {
    position: absolute;

    &[data-top] {
      ${Container}:not([data-s-top='default']) & {
        top: 0;
        display: block;
        transform: translateY(-30%);
      }

      [data-s-top='slantLeft'] & {
        right: 0;
        background: url(${svgLogoLeft}) no-repeat center right;
        height: 182px;
        width: 82px;
      }

      [data-s-top='slantRight'] & {
        left: 0;
        background: url(${svgLogoRight}) no-repeat center left;
        height: 150px;
        width: 82px;
      }
    }

    &[data-bottom] {
      ${Container}:not([data-s-bottom='default']) & {
        bottom: 0;
        display: block;
      }

      [data-s-bottom='slantLeft'] & {
        right: 0;
        background: url(${svgLogoLeft}) no-repeat center right;
        height: 160px;
        width: 82px;
      }

      [data-s-bottom='slantRight'] & {
        left: 0;
        background: url(${svgLogoRight}) no-repeat center left;
        height: 150px;
        width: 82px;
      }
    }
  }
`;
const SiteWide = styled.div `
  ${siteWide}
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    Separator,
    SeparatorLogo,
    SiteWide,
};
export default SectionWrapperStyles;
